export default "__VITE_ASSET__BnNJfKxa__"